import React from 'react';


import Event2503 from '../components/events/Event2503'

export default function EventPage() {

    return (
      <div>
        <Event2503 />
      </div>
    );
  };
  